import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { theme } from './config'
import { RightToLeft } from './utils'

const withRoot = Component => {
  const WithRoot = props => {
    let muiTheme = createMuiTheme(theme)

    return (
      <RightToLeft>
        <ThemeProvider theme={muiTheme}>
          <div dir={theme.direction}>
            <CssBaseline />
            <Component {...props} />
          </div>
        </ThemeProvider>
      </RightToLeft>
    )
  }

  return WithRoot
}

export default withRoot
